// To decode listing titles like "Ros&eacute; Vineyard" to "Rosé Vineyard"
const parseHTML = (text) => {
	var textArea = document.createElement("textarea");
	textArea.innerHTML = text;
	return textArea.value;
};

export default parseHTML;
